import {API} from "../http";

export const initMiddleware = ({dispatch, getState}) => next => action => {
	if (action.type === 'persist/REHYDRATE') {
		const {payload} = action;
		if (payload?.authKey) API.setKey(payload?.authKey);
	}
	return next(action);
};
